import React from "react";
import { Router } from "react-router-dom";
import { ReservationProvider } from "./reservation";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

type AppProvidersProps = {
  children: React.ReactNode | JSX.Element;
  browserHistory: any;
};

const defaultProps: Partial<AppProvidersProps> = {
  children: null,
};

function AppProviders({ children, browserHistory }: AppProvidersProps) {
  console.log(children);
  return (
    <QueryClientProvider client={queryClient}>
      <ReservationProvider>
        <Router history={browserHistory}>{children}</Router>
      </ReservationProvider>
    </QueryClientProvider>
  );
}

AppProviders.defaultProps = defaultProps;
export default AppProviders;
